import { Skeleton, Stack } from '@mui/material';

export const DealerDetailsSkeleton = () => (
  <Stack gap="1rem">
    <Stack gap="1rem" direction="row">
      <Skeleton variant="rectangular" sx={{ width: '50%', height: '150px' }} />
      <Skeleton variant="rectangular" sx={{ width: '50%', height: '150px' }} />
    </Stack>
    <Skeleton variant="rectangular" sx={{ height: '200px' }} />
    <Skeleton variant="rectangular" sx={{ height: '200px' }} />
  </Stack>
);
